import { Heading, Stepper } from "@/components";
import useAddEditCommunity from "./useAddEditCommunity";
import { steps } from "./consts";
import { Step1, Step2, Step3, Step4 } from "./components";
import { cn } from "@/lib/utils";

const AddEditCommunity = () => {
  const {
    currentStep,
    onNextStepClick,
    onBackClick,
    isView,
    onStepperClick,
    id,
    onPreviousStepClick,
    isMobile,
  } = useAddEditCommunity();

  return (
    <div className="p-4 md:p-6 !pt-0">
      <div className="flex flex-col lg:flex-row lg:items-center w-full justify-between">
        <Heading
          title={
            isView ? "View Community" : id ? "Edit Community" : "Add Community"
          }
          showBack
          onBackClick={onBackClick}
        />
        <div className={cn(isMobile ? "pt-4" : "pt-6 px-6")}>
          <Stepper
            steps={steps}
            currentStep={currentStep}
            onStepperClick={onStepperClick}
          />
        </div>
      </div>

      {currentStep == 1 ? (
        <Step1
          onNextClick={onNextStepClick}
          onCancel={onBackClick}
          isView={isView}
          onPreviousClick={onPreviousStepClick}
        />
      ) : currentStep == 2 ? (
        <Step2
          onNextClick={onNextStepClick}
          onCancel={onBackClick}
          isView={isView}
          onPreviousClick={onPreviousStepClick}
        />
      ) : currentStep == 3 ? (
        <Step3
          onNextClick={onNextStepClick}
          onCancel={onBackClick}
          isView={isView}
          onPreviousClick={onPreviousStepClick}
        />
      ) : currentStep == 4 ? (
        <Step4
          onNextClick={onNextStepClick}
          onCancel={onBackClick}
          isView={isView}
          onPreviousClick={onPreviousStepClick}
        />
      ) : (
        <></>
      )}  
    </div>
  );
};

export default AddEditCommunity;
